import type { SpatialObject, SpatialObjectKind } from '@/types';
import type { ObjectRenderer } from './types';
import { NoteRenderer } from './NoteRenderer';
import { WindowRenderer } from './WindowRenderer';
import { ContainerRenderer } from './ContainerRenderer';
import { FileRenderer } from './FileRenderer';
import { TerminalRenderer } from './TerminalRenderer';
import { BookmarkRenderer } from './BookmarkRenderer';
import { ImageRenderer } from './ImageRenderer';
import { ApplicationRenderer } from './ApplicationRenderer';

type RendererMap = { readonly [K in SpatialObjectKind]: ObjectRenderer<K> };

/**
 * The renderer boundary: one React component per object kind. The scene graph and
 * type definitions know nothing about this table; adding a kind means adding a type
 * definition (engine) and a renderer (here). The compiler enforces that both exist.
 */
const RENDERERS: RendererMap = {
  note: NoteRenderer,
  window: WindowRenderer,
  group: ContainerRenderer,
  folder: ContainerRenderer,
  file: FileRenderer,
  terminal: TerminalRenderer,
  bookmark: BookmarkRenderer,
  image: ImageRenderer,
  application: ApplicationRenderer,
};

export const rendererFor = <K extends SpatialObjectKind>(kind: K): ObjectRenderer<K> => RENDERERS[kind];

export type { ObjectRendererProps } from './types';
export type AnyRenderer = ObjectRenderer<SpatialObject['kind']>;
